import {Key} from 'react';

import {ReviewsAnalysisModeEnum} from '../../../service/reivew-analysis/reivew-analysis-const';
import {ReviewPhraseType} from '../../../service/reivew-analysis/review-phrases/review-phrases-type';
import {ReviewRateEnum} from '../../../service/reivew-analysis/review-rate/review-rate-type';
import {SentimentEnum} from '../../../service/reivew-analysis/review-sentiment/review-sentiment-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';

import {KeywordsAndTopicsFormTypeAggregationEnum} from './pages/keywords-and-topics-page/keywords-and-topics-form/keywords-and-topics-type';

export enum ReviewsCompareEnum {
    OFF = 'OFF',
    PERIOD = 'PERIOD',
    COMPETITOR = 'COMPETITOR',
}

export enum ReviewsAnalysisFilterEnum {
    Range = 'rwa-time-range',
    CompareRange = 'rwa-compare-range',
    Competitor = 'rwa-competitor',
    Sentiments = 'rwa-sentiments',
    Catalogs = 'rwa-catalogs',
    Tags = 'rwa-tags',
    Phrases = 'rwa-phrases',
    Topics = 'rwa-topics',
    Rates = 'rwa-rates',
    WithMessage = 'rwa-with-message',
    WithReply = 'rwa-with-reply',
    AbleToReply = 'rwa-able-to-reply',
    Target = 'target',
    TimeFormat = 'time-format',
    UseDeleted = 'use_deleted',
    UserTagsIds = 'user_tags_ids',
    AspectIds = 'aspect_ids',
    Aggregation = 'group-by',
    CompetitorCompany = 'rwa-competitor-company',
}

export const concordanceQueryName = 'rwa-cncrdnce';
export const concordanceRangeName = 'rwa-time-range';
export const concordanceContextSizeName = 'rwa-context-size';

export type ReviewsAnalysisFilterType = {
    [ReviewsAnalysisFilterEnum.Range]: [Date | null, Date | null];
    [ReviewsAnalysisFilterEnum.CompareRange]: [Date | null, Date | null];
    [ReviewsAnalysisFilterEnum.Competitor]: number | null;
    [ReviewsAnalysisFilterEnum.CompetitorCompany]: number | null;
    [ReviewsAnalysisFilterEnum.Sentiments]: Array<SentimentEnum>;
    [ReviewsAnalysisFilterEnum.Catalogs]: Array<number>;
    [ReviewsAnalysisFilterEnum.Tags]: Array<string>;
    [ReviewsAnalysisFilterEnum.Phrases]: Array<string>;
    [ReviewsAnalysisFilterEnum.Topics]: Array<string>;
    [ReviewsAnalysisFilterEnum.Rates]: Array<ReviewRateEnum>;
    [ReviewsAnalysisFilterEnum.UserTagsIds]: Array<number>;
    [ReviewsAnalysisFilterEnum.AspectIds]: Array<number>;
    [ReviewsAnalysisFilterEnum.WithMessage]: boolean | null;
    [ReviewsAnalysisFilterEnum.WithReply]: boolean | null;
    [ReviewsAnalysisFilterEnum.AbleToReply]: boolean | null;
    [ReviewsAnalysisFilterEnum.Target]: string | null;
    [ReviewsAnalysisFilterEnum.UseDeleted]: boolean | null;
    [ReviewsAnalysisFilterEnum.Aggregation]?: KeywordsAndTopicsFormTypeAggregationEnum;
    [ReviewsAnalysisFilterEnum.TimeFormat]: ReviewsAndAnswersStatisticsUnitMeasurementEnum | null;
};

export type ConcordanceQueryType = {
    [concordanceQueryName]: string;
    [ReviewsAnalysisFilterEnum.Competitor]: Array<number>;
};

export type UseReviewsAnalysisFilterType = {
    filter: ReviewsAnalysisFilterType;
    singleFilter: SingleFilterRequestType;
    comparePeriodFilter: ComparePeriodFilterRequestType;
    competitorFilter: CompetitorFilterRequestType;
    setFilter: (filterState: Partial<ReviewsAnalysisFilterType>) => void;
    queries: Record<ReviewsAnalysisFilterEnum, string | void>;
    compareMode: ReviewsCompareEnum;
};

export type PhrasesTableDataType = ReviewPhraseType & {
    key: Key;
};

export type SingleFilterRequestType = {
    startDate: string | null;
    endDate: string | null;
    sentiments: Array<SentimentEnum>;
    sources: Array<number>;
    tags: Array<string>;
    phrases: Array<string>;
    topics: Array<string>;
    userTagsIds: Array<number>;
    aspectIds: Array<number>;
    userTopics?: Array<string>;
    rating: Array<ReviewRateEnum>;
    withAnswers: boolean | null;
    withText: boolean | null;
    ableToReply: boolean | null;
    target: string | null;
    useDeleted: boolean | null;
    timeFormat: ReviewsAndAnswersStatisticsUnitMeasurementEnum | null;
};

export type ComparePeriodFilterRequestType = SingleFilterRequestType;

export type CompetitorFilterRequestType = SingleFilterRequestType & {
    brandIds: Array<number>;
    mode: ReviewsAnalysisModeEnum;
    companyIds: Array<number>;
};
